export interface EntryCountable<T> {
    entries: T[],
    entryCount: number
}

export const usePaginated = <T>(
    data: MaybeRefOrGetter<Readonly<EntryCountable<T>>>,
    entriesPerPage: MaybeRefOrGetter<Readonly<number>> = 9,
) => {
    const totalPages = computed(() => {
        return Math.ceil(toValue(data)?.entryCount / toValue(entriesPerPage)) ?? 1;
    });

    const totalEntries = computed(() => {
        return toValue(data)?.entryCount ?? 0;
    });

    const entries = computed(() => toValue(data)?.entries ?? []);

    return {
        entries,
        totalPages,
        totalEntries
    };
};
